import { AdvancedPlatformSVG } from '@sbercloud/uikit-product-icons';
import { PLATFORM } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var ADVANCED_PLATFORM = {
  id: PLATFORM.Advanced,
  icon: /*#__PURE__*/_jsx(AdvancedPlatformSVG, {}),
  label: 'Advanced Cloud.ru',
  description: '60+ IaaS- и PaaS-сервисов для развития инфраструктуры',
  access: 'request',
  dataTestId: 'calculator-catalog-platform-advanced'
};